import { all, fork } from "redux-saga/effects";
import {
  watchVisualSearchSaga,
  watchGetProductsSaga,
  watchGetFavoritesSearchSaga,
  watchGetOutfitsSaga,
  watchSetOutfitFavoriteSaga,
  watchGetOutfitFavoritesSearchSaga,
  watchSendUploadedImageSaga,
  watchPostFavoritesItemSaga,
  watchDeleteFavouritesItemSaga,
  watchFetchProductSKUs,
  watchFetchProductL2WithImage,
  watchGetFavoritesItemSaga
} from "./searchResult";

export default function* rootSaga(): Generator {
  yield all([
    fork(watchVisualSearchSaga),
    fork(watchGetProductsSaga),
    fork(watchGetFavoritesSearchSaga),
    fork(watchGetOutfitsSaga),
    fork(watchGetOutfitFavoritesSearchSaga),
    fork(watchSetOutfitFavoriteSaga),
    fork(watchSendUploadedImageSaga),
    fork(watchPostFavoritesItemSaga),
    fork(watchDeleteFavouritesItemSaga),
    fork(watchFetchProductSKUs),
    fork(watchFetchProductL2WithImage),
    fork(watchGetFavoritesItemSaga)
  ]);
}
